import { RootState } from '@/store';

export const selectors = {
	region: {
		get: (state: RootState) => state.regionCampaigns.region
	},
	regionCampaign: {
		get: (state: RootState) => state.regionCampaigns.regionCampaign,
		getData: (state: RootState) =>
			state.regionCampaigns.regionCampaign.data,
		getLoaded: (state: RootState) =>
			state.regionCampaigns.regionCampaign.loaded
	},
	regionCampaigns: {
		get: (state: RootState) => state.regionCampaigns.regionCampaigns,
		getData: (state: RootState) =>
			state.regionCampaigns.regionCampaigns.data,
		getLoaded: (state: RootState) =>
			state.regionCampaigns.regionCampaigns.loaded
	},
	regionCampaignUpdate: {
		get: (state: RootState) => state.regionCampaigns.regionCampaignUpdate,
		getData: (state: RootState) =>
			state.regionCampaigns.regionCampaignUpdate.data,
		getLoaded: (state: RootState) =>
			state.regionCampaigns.regionCampaignUpdate.loaded
	},
	regionCampaignUpdates: {
		get: (state: RootState) => state.regionCampaigns.regionCampaignUpdates,
		getData: (state: RootState) =>
			state.regionCampaigns.regionCampaignUpdates.data,
		getLoaded: (state: RootState) =>
			state.regionCampaigns.regionCampaignUpdates.loaded
	},
	campaignSettings: {
		get: (state: RootState) => state.regionCampaigns.campaignSettings
	},
	campaignSetting: {
		get: (state: RootState) => state.regionCampaigns.campaignSetting
	},
	regionsByCampaign: {
		get: (state: RootState) => state.regionCampaigns.regionsByCampaign
	}
};
